import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import TechnologySection from './components/TechnologySection';
import TrustSection from './components/TrustSection';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-8 py-6 flex items-center justify-between">
          <div className="flex items-center">
            <h1 className="text-3xl font-bold text-[#1E293B]">DocAI</h1>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#cozumler" className="text-[#64748B] hover:text-[#2563EB] transition-colors text-base font-medium">
              Çözümler
            </a>
            <a href="#teknoloji" className="text-[#64748B] hover:text-[#2563EB] transition-colors text-base font-medium">
              Teknoloji
            </a>
            <a href="#hakkimizda" className="text-[#64748B] hover:text-[#2563EB] transition-colors text-base font-medium">
              Hakkımızda
            </a>
            <a href="#iletisim" className="text-[#64748B] hover:text-[#2563EB] transition-colors text-base font-medium">
              İletişim
            </a>
          </div>
          <button 
            onClick={() => window.open('https://wa.me/905370102404?text=Merhaba%2C%20DocAI%20demosunu%20g%C3%B6rmek%20istiyorum', '_blank')}
            className="bg-[#2563EB] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#1d4ed8] transition-all whitespace-nowrap cursor-pointer"
          >
            Demo İste
          </button>
        </div>
      </nav>

      {/* Main Content */}
      <Hero />
      <ProblemSection />
      <TechnologySection />
      <TrustSection />
      <Footer />
    </div>
  );
}
